import React from 'react';
import PropTypes from 'prop-types';

import env from 'Env';
import StarRating from 'Components/ProductReviews/UserReviews/StarRating';
import 'Components/Carousel/FeaturedCarouselPanels/PanelComponents/ReviewSection.scss';

export default function ReviewSection({ hit, siteTheme }) {
  const scoreThreshold = env.percentRecommendedThreshold;

  const showReviews = (hit.rating_score
  || (hit.metacritic_score && hit.metacritic_score >= scoreThreshold)
  || (hit.opencritic_score && hit.opencritic_score >= scoreThreshold))
  && !hit.preorder;

  if (!showReviews) return false;

  const showMetacritic = (hit.metacritic_score && hit.metacritic_score) >= scoreThreshold;
  const showOpencritic = (hit.opencritic_score && hit.opencritic_score) >= scoreThreshold;

  return (
    <div className="ReviewSection__reviews CarouselPanel__section">
      {/* We only want to show the score if its atleast 4 stars */}
      {(!!hit.rating_score && hit.rating_score >= 4) &&
        <div className="ReviewSection__stars">
          <StarRating rating={hit.rating_score} />
          ({hit.total_ratings})
        </div>
      }

      {showMetacritic &&
        <div className="ReviewSection__critics">
          <div className="ReviewSection__criticsScore">
            {hit.metacritic_score}
          </div>
          <div className="ReviewSection__criticsLogo ReviewSection__criticsLogo--metacritic">
            <img src={`https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-full-${siteTheme === 'light' ? 'black' : 'white'}.svg`} alt="" />
          </div>
        </div>
      }

      {!showMetacritic && showOpencritic &&
        <div className="ReviewSection__critics">
          <div className="ReviewSection__criticsScore">
            {hit.opencritic_score}
          </div>
          <div className="ReviewSection__criticsLogo ReviewSection__criticsLogo--opencritic">
            <img src={`https://cdn.fanatical.com/production/brand/opencritic/svg/opencritic-full-${siteTheme === 'light' ? 'black' : 'white'}.svg`} alt="" />
          </div>
        </div>
      }
    </div>
  );
}

ReviewSection.propTypes = {
  hit: PropTypes.shape({}).isRequired,
  siteTheme: PropTypes.string,
};

ReviewSection.defaultProps = {
  siteTheme: '',
};
